// extracted by mini-css-extract-plugin
export var label = "_q8-0";
export var link = "_q8-1";